/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Status type of the device update.
 */
export enum DeviceUpdatedStatusType {
  DeviceUpdatedStatusUpToDate = 'UpToDate',
  DeviceUpdatedStatusOutOfDate = 'OutOfDate',
  DeviceUpdatedStatusUpdating = 'Updating',
  DeviceUpdatedStatusUnknown = 'Unknown',
}
